import {Input} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function PersianNumberInput({label, extension, value, setValue}) {

  function extractNumbers(inputString) {

    const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
    const englishDigits = '0123456789';

    const persianFormattedNumber = [...String(inputString)]
      .map((digit) => {
        return englishDigits[persianDigits.indexOf(digit)] || digit
      })
      .join('');

    const extractedNumbers = persianFormattedNumber.replace(/\D/g, ""); // Remove all non-digit characters


    return parseInt(extractedNumbers, 10); // Convert the result to an integer
  }

  const [renderedValue, setRenderedValue] = useState(`${persianNumberFormat(value ? value : 0, true)} ${extension}`)

  useEffect(() => {
    const new_rendered = `${persianNumberFormat(value ? value : 0, true)} ${extension}`
    setRenderedValue(new_rendered)
  }, [value]);

  return (
    <Input variant="standard"
           value={renderedValue}
           label={label}
           placeholder={label}
           onChange={(e) => {
             let raw_number = extractNumbers(e.target.value)
             let new_rendered = `${persianNumberFormat(extractNumbers(e.target.value), true)} ${extension}`
             setRenderedValue(new_rendered)
             setValue(raw_number)
           }}
    />
  );
}